import { render, staticRenderFns } from "./DashboardTablePartenaires.vue?vue&type=template&id=041e074e&scoped=true&"
import script from "./DashboardTablePartenaires.vue?vue&type=script&lang=js&"
export * from "./DashboardTablePartenaires.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTablePartenaires.vue?vue&type=style&index=0&id=041e074e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041e074e",
  null
  
)

export default component.exports